import { useCallback, useEffect, useMemo, useState } from 'react'
import { ClientSummary, fetchClients } from '@/services/invoiceService'

export interface UseClientsReturn {
  clients: ClientSummary[]
  isLoading: boolean
  error: string | null
  reload: () => Promise<void>
}

export function useClients(): UseClientsReturn {
  const [clients, setClients] = useState<ClientSummary[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const loadClients = useCallback(async () => {
    setIsLoading(true)
    setError(null)
    try {
      const list = await fetchClients()
      setClients(list)
    } catch (err) {
      console.error('Failed to load clients', err)
      setError(err instanceof Error ? err.message : 'Failed to load clients')
      setClients([])
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    void loadClients()
  }, [loadClients])

  return useMemo(
    () => ({ clients, isLoading, error, reload: loadClients }),
    [clients, isLoading, error, loadClients]
  )
}

